import { useModel } from '@@/plugin-model/useModel';

/**
 * 是否有新建打卡营的权限
 * */
function useIsHaveCreateCampAuth() {
  const { initialState } = useModel('@@initialState');
  return initialState.permission?.superAdmin || initialState.permission?.createCamp;
}
export default useIsHaveCreateCampAuth;
